import { render, staticRenderFns } from "./backstage.vue?vue&type=template&id=eea589e4&scoped=true"
import script from "./backstage.vue?vue&type=script&lang=js"
export * from "./backstage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea589e4",
  null
  
)

export default component.exports